import React from 'react';
import { Button } from '@/components/common';

// Composant temporaire pour le développement - À SUPPRIMER en production
export const DevLogin: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">
            AMV Gomecano - Mode Développement
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Connexion temporaire pour les tests
          </p>
          <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-md">
            <p className="text-sm text-yellow-800">
              ⚠️ Mode développement : Aucune authentification requise
            </p>
          </div>
        </div>
        
        <div className="space-y-4">
          <Button 
            onClick={onLogin}
            className="w-full"
            size="lg"
          >
            Accéder au Back-Office (Dev Mode)
          </Button>
          
          <div className="text-center">
            <p className="text-xs text-gray-500">
              Pour créer un vrai compte utilisateur :
              <br />
              1. Allez sur votre dashboard Supabase
              <br />
              2. Authentication &gt; Users &gt; Add user
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
